export default __webpack_public_path__ + "static/media/icn-handbrake.3008d24d.svg";